// Single source of truth for brand facts used across pages, schema and meta.
export const BUSINESS = {
  brandName: 'Ikonomakis Hair Atelier',
  siteUrl: 'https://ikonomakis.gr',
  logoUrl: 'https://media.base44.com/images/public/69d96446735f4e1f0f7d5bbf/4af79f86a_1.png',
  // Landscape (1024×683) — social cards need ~1.91:1; the portrait hero shot crops badly on share
  ogImage: 'https://media.base44.com/images/public/69d96446735f4e1f0f7d5bbf/bfc9fefaf_0S9A0510.jpg',
  ogImageAlt: 'Ο Θοδωρής Οικονομάκης στο Ikonomakis Hair Atelier, Χαλάνδρι',
  founderName: 'Θοδωρής Οικονομάκης',
  // Νομικό πρόσωπο / υπεύθυνος επεξεργασίας — χρησιμοποιείται στις σελίδες όρων & απορρήτου
  legalEntityName: 'Έλενα Σκουρλά',
  founderNameEn: 'Thodoris Ikonomakis',
  founderSameAs: [
    'https://www.instagram.com/ikonomakis_hairexpert/',
    'https://www.instagram.com/haircommunitygreece/',
  ],
  phone: '211 800 4132',
  phoneHref: 'tel:+302118004132',
  phoneIntl: '+30-211-800-4132',
  email: 'info@ikonomakis.gr',
  address: { street: 'Ηρακλείτου 80', locality: 'Χαλάνδρι', region: 'Αττική', postalCode: '15238', country: 'GR' },
  geo: { latitude: '38.0235', longitude: '23.8005' },
  // Single source of truth for review facts. Public UI must use `reviews.display`
  // (exact Fresha count, last synced 2026-10-12).
  reviews: {
    rating: '4.9',
    display: '2.199',
    displayEn: '2,199',
    exactReviewCount: 2199,
    reviewLastVerified: '2026-10-12',
    get summary() { return `${this.rating}/5 · ${this.display} verified reviews`; },
    get summaryEl() { return `${this.rating}/5 από ${this.display} πιστοποιημένες κριτικές`; },
  },
  rating: { value: '4.9', count: '2199' },
  bookingUrl: 'https://www.fresha.com/a/ikonomakis-hair-atelier-halandri-irakleitoy-80-bxynmijf?pId=770996',
  // Google review CTA — opens the salon's Google listing (review dialog on Maps).
  googleReviewUrl: 'https://www.google.com/maps/search/?api=1&query=Ikonomakis+Hair+Atelier+%CE%97%CF%81%CE%B1%CE%BA%CE%BB%CE%B5%CE%AF%CF%84%CE%BF%CF%85+80+%CE%A7%CE%B1%CE%BB%CE%AC%CE%BD%CE%B4%CF%81%CE%B9',
  pricing: { haircutFrom: 45, colorFrom: 43, balayageFrom: 150, keratinFrom: 150, k18From: 45, milbonFrom: 195, mensPermFrom: 70, faceMetricsAtelier: 100 },
  // Face Metrics Pro: the atelier service is €100 / 45 min with Thodoris Ikonomakis.
  // The €50 figure is a DIFFERENT product (the standalone online/app analysis) and must
  // never be published as the atelier price or as a price range.
  faceMetrics: {
    atelier: { price: 100, minutes: 45, label: 'Face Metrics Pro (atelier, με τον Θοδωρή Οικονομάκη)' },
    onlineApp: { price: 50, label: 'Face Metrics Pro Online (ξεχωριστό online προϊόν)' },
  },
  canonical: {
    founder: '/thodoris-ikonomakis-hair-expert',
    faceMetrics: '/services/face-metrics-pro',
    balayage: '/balayage-chalandri',
  },
};